import {api, BASE_URL} from "../config";
import { getCurrentLanguage } from "../i18n";

const FILES_URL = BASE_URL + "documents/"; // ex: /api/files/
const DOCUMENT_VERSION_URL = BASE_URL + "documents/versions/";


export const getVersionContent = (versionId) => {
    return api.get(`${DOCUMENT_VERSION_URL}${versionId}/content`)
        .then(res => res.data)
        .catch(error => {
            console.error("Error fetching version content:", error);
            throw error;
        });
};

export function deleteAmendment(doc_id) {
    return api.delete(`/documents/${doc_id}`).then((res) => res.data);
}

export async function createAmendment(payload) {
    return api.post('/documents/', payload)
        .then(res => res.data)
        .catch(error => {
            console.error("Error creating amendment:", error);
            throw error;
        });
}

export async function createVersion(payload) {
    return api.post('/documents/replace_main', payload)
        .then(res => res.data)
        .catch(error => {
            console.error("Error creating version:", error);
            throw error;
        });
}

export async function download_document_version(versionId) {
    const url = await get_document_version_download_url(versionId);
    if (!url) throw new Error("URL de téléchargement introuvable");
    window.location.assign(url); // direct S3
}

export async function download_document(docId) {
    const url = await get_document_download_url(docId);
    if (!url) throw new Error("URL de téléchargement introuvable");
    window.location.assign(url);
}



export const getVersionStatus = (versionId) => {
    return api.get(`${DOCUMENT_VERSION_URL}${versionId}/status`)
        .then(res => res.data)
        .catch(error => {
            console.error("Error fetching version status:", error);
            throw error;
        });
};

export const detectVersionParties = (versionId) => {
    return api.post(
        `${DOCUMENT_VERSION_URL}${versionId}/party-detection`,
        {},
        { headers: { "X-Client-Language": getCurrentLanguage() } }
    )
        .then(res => res.data)
        .catch(error => {
            console.error("Error detecting contract parties:", error);
            throw error;
        });
};

export const updateDocumentVersionTitle = (versionId, title) => {
    return api.put(`${DOCUMENT_VERSION_URL}${versionId}/title`, { title })
        .then(res => res.data)
        .catch(error => {
            console.error("Error updating version title:", error);
            throw error;
        });
};



export async function get_document_version_download_url(versionId) {
    const res = await api.get(`${DOCUMENT_VERSION_URL}${versionId}/download-url`);
    return res.data?.data?.url;
}

export async function get_document_download_url(docId) {
    const res = await api.get(`${FILES_URL}${docId}/download-url`);
    return res.data?.data?.url;
}
